import { MobileScreenRecord } from "../../types/immutableRecords/model/mobileScreen/MobileScreenRecord";
import { actionTypes } from "./actions";

const reducer = (state = MobileScreenRecord(), action) => {
  if (action.type === actionTypes.CHANGE_MOBILE_SCREEN_WIDTH) {
    return state.merge({
      screenWidth: action.width,
      isPortraitMode: action.isMobilePortrait
    });
  }
  return state;
};

export default reducer;
